/**
 * Shared form styling for the field surface.
 *
 * These live in one module rather than beside each form because the
 * point of them is that every input looks identical. When the account
 * dialog kept its own copy, the fields added to it later fell through
 * to MUI's default blue focus ring — a colour that appears nowhere
 * else in the product — and the form stopped reading as one surface.
 */

export const INK = '#0f0a07';
export const GOLD = '#bb8c3f';
export const IVORY = '#fdf9f0';
export const HAIRLINE = 'rgba(187, 140, 63, 0.22)';
export const DANGER = '#c0492f';
export const FONT_INTER = '"Inter", "Avenir", -apple-system, BlinkMacSystemFont, sans-serif';

/** Every text input on the field forms wears this. */
export const FIELD_SX = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    bgcolor: '#fff',
    transition: 'box-shadow 180ms ease, border-color 180ms ease',
    '& fieldset': { borderColor: 'rgba(15, 10, 7, 0.13)' },
    '&:hover fieldset': { borderColor: 'rgba(187, 140, 63, 0.5)' },
    '&.Mui-focused': { boxShadow: '0 0 0 3px rgba(187, 140, 63, 0.14)' },
    '&.Mui-focused fieldset': { borderColor: GOLD, borderWidth: 1 },
    '&.Mui-error fieldset': { borderColor: DANGER },
    '&.Mui-error.Mui-focused': { boxShadow: '0 0 0 3px rgba(192, 73, 47, 0.12)' },
  },
  '& .MuiInputBase-input': { fontFamily: FONT_INTER, fontSize: 14 },
  '& .MuiInputLabel-root': { fontFamily: FONT_INTER, fontSize: 14 },
  '& label.Mui-focused': { color: GOLD },
} as const;

/** Helper text in the form's own voice rather than MUI's default. */
export const HELPER_SX = {
  sx: { fontFamily: FONT_INTER, fontSize: 11, ml: 0.25, mt: 0.5 },
} as const;

/** A quiet gold text button — "Add Another Phone", "Add Contact". */
export const QUIET_ACTION_SX = {
  fontFamily: FONT_INTER,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: 12.5,
  color: GOLD,
  borderRadius: 1.5,
  px: 1,
  '&:hover': { bgcolor: 'rgba(187, 140, 63, 0.08)' },
} as const;
